import request from "../axios-instance";

import { ApiError } from "../errors";
import {
  GetCategoriesResponse,
  GetCellOfRoleResponse,
  GetDsdViewResponse,
  GetDsdViewsByNoteNumbersResponse,
  GetRegisteredTableListResponse,
  GetTableAddressesResponse,
  GetTablesTaggingStatusResponse,
  GetWorkbookResponse,
} from "./types";

export const getTableAddresses = async (
  workbookId: string,
): Promise<GetTableAddressesResponse> => {
  const response = await request.get(
    `/v1/workbooks/${workbookId}/table-addresses`,
  );

  return response.data;
};

export const getWorkbook = async (
  workbookId: string,
): Promise<GetWorkbookResponse> => {
  try {
    const response = await request.get(`/v1/workbooks/${workbookId}`);

    return response.data;
  } catch (error) {
    if (error instanceof ApiError && error.statusCode === 404) {
      return {
        id: null,
        name: "",
        displayName: null,
        revision: 0,
        creator: "",
        companyName: "",
        companyCode: "",
        announcementDate: null,
        reportQuarter: null,
        reportYear: null,
        fiscalYearNumber: null,
        financialStatementType: null,
        industry: null,
        createdAt: new Date(),
        updatedAt: new Date(),
      };
    }
    console.error("Error: " + error);
    throw new Error("Failed to get workbook");
  }
};

export const getRegisteredTableList = async (
  workbookId: string,
): Promise<GetRegisteredTableListResponse> => {
  const response = await request.get(`/v1/workbooks/${workbookId}/tables`);

  return response.data;
};

export const getCategories = async (
  workbookId: string,
): Promise<GetCategoriesResponse> => {
  const response = await request.get(`/v1/workbooks/${workbookId}/categories`);

  return response.data as GetCategoriesResponse;
};

export const getDsdView = async (
  workbookId: string,
  tableId: string,
): Promise<GetDsdViewResponse> => {
  const response = await request.get(
    `/v1/workbooks/${workbookId}/tables/${tableId}/dsd-view`,
  );
  return response.data;
};

export const getDsdViewsByNoteNumbers = async (
  workbookId: string,
  noteNumbers: string[],
): Promise<GetDsdViewsByNoteNumbersResponse> => {
  const response = await request.post(
    `/v1/workbooks/${workbookId}/note-categories/dsd-views`,
    { noteNumbers },
  );
  return response.data;
};

export const updateWorkbook = async (
  workbookId: string,
  displayName: string,
) => {
  const response = await request.patch(`/v1/workbooks/${workbookId}`, {
    displayName,
  });

  return response.data;
};

export const getCellOfRole = async (
  workbookId: string,
  tableId: string,
  cellAddress?: string,
): Promise<GetCellOfRoleResponse> => {
  if (!cellAddress) {
    throw Error("cellAddress is required");
  }
  const response = await request.get(
    `/v1/workbooks/${workbookId}/tables/${tableId}/cells/${cellAddress}/role`,
  );

  return response.data;
};

export const getTablesTaggingStatus = async (
  workbookId: string,
): Promise<GetTablesTaggingStatusResponse> => {
  const response = await request.get(
    `/v1/workbooks/${workbookId}/tables-tagging-status`,
  );
  return response.data;
};
